import styled from 'styled-components';

export const Indicator = styled.div`
  position: fixed;
  top: -40px;
  left: 50%;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  color: #f78e1e;
  font-size: 20px;
  pointer-events: none;
`;
